import { render, staticRenderFns } from "./NevronTableGeneric.vue?vue&type=template&id=706bce1e&scoped=true&"
import script from "./NevronTableGeneric.vue?vue&type=script&lang=ts&"
export * from "./NevronTableGeneric.vue?vue&type=script&lang=ts&"
import style0 from "./NevronTableGeneric.vue?vue&type=style&index=0&id=706bce1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706bce1e",
  null
  
)

export default component.exports